import React from "react";
import { Triangle } from "react-loader-spinner";

export default function Loading() {
  return <Triangle height='100' width='100' color='cyan' ariaLabel='loading' />;
}
